/* eslint-disable react-hooks/exhaustive-deps */
"use client";

import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import { PRODUCT_DOMAIN, SINGLE_TRIP } from "@/constants";
import usePtmmExitModalDetails, {
  variationsForBE,
} from "@/hooks/api/quote/ptm-exit-modal-details";
import { RootState } from "@/store/root-reducer";
import { PtmExitModalType } from "@/utils/schema/quote-page-schema.utils";

import { sessionStatus, STORAGE_KEY } from "./exit-intent-trigger.hook";
import PtmExitModal from "./ptm-exit-modal";

export default function PtmExitModalWrapper({
  ptmExitModalContent,
}: Readonly<{
  ptmExitModalContent?: PtmExitModalType;
}>) {
  const triggeredRef = useRef(false);
  const { attributes, version } = useSelector(
    (state: RootState) => state.quote
  );
  const { passModalDetails } = usePtmmExitModalDetails();
  const latestVersion = useRef(version);
  const tripDetails = attributes?.tripDetails;
  const isPTMeligible = attributes?.priceResult?.ecoSystem?.eligibility;
  const variation = attributes?.priceResult?.ecoSystem?.variation;
  const latestVariation = useRef(variation);
  const latestIsPTMeligible = useRef(isPTMeligible);

  const triggeredExperiment = () => {
    if (["AVN", "STS"].includes(PRODUCT_DOMAIN) === false) return;
    if (sessionStorage.getItem(STORAGE_KEY) !== null) return;
    triggeredRef.current = true;
  };

  const passDataToBE = (versionNumber: string, variationValue: string) => {
    const sessionValue = sessionStorage.getItem(STORAGE_KEY);
    // EcoSystem eligible and modal is pop-up and data already pass to BE
    if (sessionValue === sessionStatus.DONE) return;
    if (latestIsPTMeligible.current !== true) return;
    if (
      [
        variationsForBE.variantA,
        variationsForBE.variantB,
        variationsForBE.control,
      ].includes(`${latestVariation.current}`) === false
    )
      return;
    // EcoSystem eligible and varient set as (A|B|control) and modal did'n pop-up
    passModalDetails({
      modalLoaded: false,
      modalLoadedEvent: null,
      variation: variationValue,
      version: versionNumber,
    });
  };

  useEffect(() => {
    latestVersion.current = version;
    latestVariation.current = variation;
    latestIsPTMeligible.current = isPTMeligible;
  }, [version, variation, isPTMeligible]);

  useEffect(() => {
    if (
      isPTMeligible &&
      triggeredRef.current === false &&
      [variationsForBE.variantA, variationsForBE.variantB].includes(
        `${variation}`
      )
    ) {
      triggeredExperiment();
    }
  }, [isPTMeligible, variation]);

  useEffect(() => {
    return () => {
      passDataToBE(`${latestVersion.current}`, `${latestVariation.current}`);
    };
  }, []);

  if (["AVN", "STS"].includes(PRODUCT_DOMAIN) === false) return null;
  if (tripDetails?.policyType !== SINGLE_TRIP) return null;
  if (triggeredRef.current === false) return null;
  if (isPTMeligible !== true) return null;
  return <PtmExitModal ptmExitModalContent={ptmExitModalContent} />;
}
